import React from 'react';

const CharacterCounter = ({ text, limit }) => {
  let remainingCharacters;
  if (!text?.length) {
    remainingCharacters = limit;
  } else {
    remainingCharacters = limit - text?.length;
  }
  const isNegative = remainingCharacters < 0;

  return (
    <div className={isNegative ? 'text-red-500' : ''}>
      {remainingCharacters} characters left
    </div>
  );
};

export default CharacterCounter;
